<div class="screen">

  <!-- ── Hero ── -->
  <div class="hero-card" [attr.data-tension]="tension()">

    <div class="hero-top">
      <div class="hero-site-info">
        <p class="hero-eyebrow">{{ 'mobileSimulator.common.monSite' | translate }}</p>
        <h1 class="hero-name">{{ siteName }}</h1>
      </div>
      <span class="hero-badge" [attr.data-tension]="tension()">
        <span class="hero-badge-dot" [attr.data-tension]="tension()"></span>
        {{ tensionLabel() }}
      </span>
    </div>

    <div class="hero-metrics">
      <div class="hero-metric">
        <span class="hm-val">38</span>
        <span class="hm-lbl">{{ 'mobileSimulator.common.surSite' | translate }}</span>
      </div>
      <div class="hm-sep"></div>
      <div class="hero-metric">
        <span class="hm-lbl">{{ 'mobileSimulator.monSite.activityLabel' | translate }}</span>
        <span class="hm-val hm-val--text">{{ 'mobileSimulator.monSite.activityVeryHigh' | translate }}</span>
      </div>
    </div>

    @if (deriveMinutes() > 0) {
      <div class="hero-derive">
        <span class="derive-dot"></span>
        <span>{{ 'mobileSimulator.monSite.degradationSincePrefix' | translate }} <strong>{{ deriveMinutes() }} min</strong></span>
      </div>
    }

  </div>

  <!-- ── Historique ── -->
  <p class="section-label section-label--link">{{ 'mobileSimulator.common.historique' | translate }}</p>
  <div class="card-timeline">
    @for (slot of getTimelineSlots(); track slot; let i = $index) {
      <div class="tl-col">
        <span class="tl-dot" [style.background]="tlColor(timeline[i])"></span>
        <span class="tl-time">{{ slot }}</span>
      </div>
    }
  </div>

  <!-- ── Actions rapides ── -->
  <p class="section-label section-label--link">{{ 'mobileSimulator.common.actionsRapides' | translate }}</p>

  @if (actionSent()) {
    <div class="confirm-toast">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
      </svg>
      <span>{{ 'mobileSimulator.common.actionEnvoyee' | translate }} · <strong>{{ actionSent() }}</strong></span>
    </div>
  }

  <div class="actions-grid">
    @for (action of actions; track action.id) {
      <button class="action-card" (click)="action.id === 'renfort' ? openRenfort.emit() : action.id === 'degrade' ? openModeDegrade.emit() : action.id === 'patient' ? openCommPatient.emit() : action.id === 'canal' ? openCanal.emit() : sendAction(action.label)">
        <span class="action-icon">{{ action.icon }}</span>
        <span class="action-label">{{ action.label }}</span>
      </button>
    }
  </div>

  <!-- ── Mon statut ── -->
  <p class="section-label section-label--link">{{ 'mobileSimulator.monSite.myStatusTitle' | translate }}</p>

  <div class="my-card" [class.my-card--dispo]="myStatus() === 'disponible'">
    <div class="my-top">
      <div class="my-left">
        <div class="my-avatar-wrap">
          <div class="my-avatar" [class.my-avatar--dispo]="myStatus() === 'disponible'">A</div>
          <span class="my-presence-dot" [attr.data-status]="myStatus()"></span>
        </div>
        <div class="my-info">
          <p class="my-name">Alexandre M.</p>
          <p class="my-role">Biologiste</p>
        </div>
      </div>
      <button class="status-toggle" (click)="toggleStatus()">
        <div class="toggle-track" [class.toggle-track--on]="myStatus() === 'disponible'">
          <span class="toggle-thumb"></span>
        </div>
      </button>
    </div>
    <span class="my-badge" [attr.data-status]="myStatus()">
      {{ activeActionLabel() ?? myStatusLabel() }}
    </span>
  </div>

  <!-- ── Signaler ma disponibilité ── -->
  <p class="section-label section-label--link">{{ 'mobileSimulator.common.signalerDispo' | translate }}</p>

  <div class="actions-list">
    @for (action of myActions; track action.id) {
      <button class="action-row" [class.action-row--active]="activeActionId() === action.id" (click)="sendTeamAction(action.label, action.dispo, action.id)">
        <span class="action-icon">{{ action.icon }}</span>
        <span class="action-label">{{ action.label }}</span>
        <button class="action-notif-btn" (click)="sendTeamAction(action.label, action.dispo, action.id); openNotifAide.emit(); $event.stopPropagation()">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
          </svg>
        </button>
      </button>
    }
  </div>

  <!-- ── Équipe réseau ── -->
  <p class="section-label section-label--link">{{ 'mobileSimulator.monSite.myTeamTitle' | translate }} · {{ 'mobileSimulator.common.membersCount' | translate: { count: collegues().length } }}</p>

  <div class="team-list">
    @for (c of collegues(); track c.id) {
      <div class="membre-item">
        <div class="membre-info">
          <span class="membre-nom">{{ c.nom }}</span>
          <span class="membre-meta">{{ c.role }}</span>
        </div>
        <span class="dispo-chip" [attr.data-dispo]="c.dispo">
          @if (c.dispo === 'disponible') {
            <span class="dispo-dot dispo-dot--pulse"></span>
          }
          @if (c.dispo === 'occupé') {
            <svg width="9" height="9" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
            </svg>
          }
          @if (c.dispo === 'en-route') {
            <svg width="9" height="9" viewBox="0 0 24 24" fill="currentColor">
              <path d="M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z"/>
            </svg>
          }
          {{ dispoLabel(c.dispo) }}
        </span>
        <button class="msg-btn" (click)="sendMessage(c.nom)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
          </svg>
        </button>
      </div>
    }
  </div>

</div>